export const useChecklistControllerStore = (documentId: string) => {
  return useChecklistController(documentId)();
};
